import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AlertBar } from '../../Modals/AlertBar';
import { withNamespaces } from 'react-i18next';

import { Redirect } from 'react-router';
import { checkPrivileges } from "../../../util/util";
import { Alert } from '../../Modals/AlertBar';

class ReportPortal extends Component {
    constructor(props) {
        super(props);
    }

    onClickReport = (reportName) => {
        const { gotoReport } = this.props;
        console.log('onClickReport:::::');
        gotoReport(reportName);
    }

    render() {
        const { t } = this.props;
        if (!checkPrivileges("report")) {
            Alert(t('คุณไม่มีสิทธิ์ ดูรายงาน'), t('กรุณาติดต่อผู้ดูแล้วระบบ'));
            return <Redirect push to="/main" />;
        }

        return (
            <div className="gray-panel" >
                <div className="col-md-8">
                    <h1 className="page-header">
                        <i className="fas fa-file-contract" style={{ color: '#7386D5' }} />{t('รายงานทั้งหมด')}
                    </h1>
                </div>
                <div className="row">
                    <div className="col-md-4 row">
                    </div>
                </div>
                <div className="col-md-1">
                </div>
                <hr />
                <div className="" style={{ minHeight: "calc(100vh - 150px)" }}>

                    <h5 className="no-margin">
                        <span className="fa-stack fa-lg" style={{ color: '#2196f3' }}>
                            <i className="fa fa-circle fa-stack-2x " />
                            <i className="fa fa-bars fa-stack-1x" style={{ color: 'white' }} />
                        </span>
                        {t('รายงานข้อมูล')}
                    </h5>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportUsageSummary')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('สรุปการใช้งาน')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportSummary')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('สรุปการใช้งานรายคัน')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportSummaryByGroup')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('สรุปการใช้งานตามกลุ่ม')}
                                </button>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportWorkingHours')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('ชั่วโมงการทำงาน')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportEventAlert')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('รายงานการแจ้งเตือน')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportRoute')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('รายงานเส้นทางการวิ่ง')}
                                </button>
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportDistance')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('รายงานระยะทางการวิ่ง')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportStop')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('รายงานการจอดรถ')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportPoiInOut')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('เข้า-ออก POI')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('เข้า-ออก พื้นที่')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('reportRFID')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('การรูดบัตร')}
                                </button>
                            </div>
                        </div>


                    </div>
                    <hr />
                    <h5 className="no-margin">
                        <span className="fa-stack fa-lg" style={{ color: '#f44336' }}>
                            <i className="fa fa-circle fa-stack-2x" />
                            <i className="fas fa-chart-bar fa-stack-1x" style={{ color: 'white' }} />
                        </span>
                        {t('รายงานกราฟ')}
                    </h5>
                    <div className="form-group">

                        <div className="row">

                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('GraphFuel')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('กราฟน้ำมัน')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('กราฟก๊าซ')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('GraphSpeed')}>
                                    <i className="fa fa-fw fa-file-text-o" />{t('กราฟความเร็ว')}
                                </button>
                            </div>


                        </div>

                        <div className="row">

                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} onClick={() => this.onClickReport('GraphHeat')} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('กราฟอุณหภูมิ')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('กราฟแรงดันไฟฟ้า')}
                                </button>
                            </div>


                        </div>

                    </div>

                    <hr />
                    <h5 className="no-margin">
                        <span className="fa-stack fa-lg" style={{ color: '#4caf50' }}>
                            <i className="fa fa-circle fa-stack-2x" />
                            <i className="fa fa-picture-o fa-stack-1x" style={{ color: 'white' }} />
                        </span>
                        {t('รายงานรูปภาพ')}
                    </h5>

                    <div className="form-group">


                        <div className="row">

                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('รูปภาพจากตัวอุปกรณ์')}
                                </button>
                            </div>
                            <div className="col-md-4">
                                <button type="button" className="btn btn-block btn-light text-left" style={{ border: '1px solid #CCC', margin: '5px 0px', padding: 10, }} >
                                    <i className="fa fa-fw fa-file-text-o" />{t('กล้อง DVR')}
                                </button>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

ReportPortal.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    gotoReport: PropTypes.func.isRequired
}

export default withNamespaces('Menubar')(ReportPortal);



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportPortal.js